import {
  EditableTable,
  RegAuthHeaderCell,
} from "../generic/editableTable/editableTable.component";
import { Table } from "rsuite";
import { ActionCell } from "./ActionCellAdmin.component";
import { useState, useEffect, useMemo } from "react";
import { ApiSchemaAdmin } from "../../models/api/apiSchemaAdmin";
import { ApiAdmin } from "../../core/apis/admin";
import { BadgeCell } from "../generic/editableTable/badgeCell.component";
import { DateCell } from "../generic/editableTable/dateCell.component";
import { showErrorToast, showSuccessToast } from "../generic/toast.component";
import { useHeightUptoBottom } from "../hooks/useHeightToBottomById";
const { Column, Cell } = Table;
type TableData = ApiSchemaAdmin & { serial: number };

export const AdminsTable = ({ searchKey }: { searchKey: string }) => {
  const [data, setData] = useState<TableData[]>();
  const [loading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    getAdminUserList();
  }, []);

  const getAdminUserList = () => {
    ApiAdmin.getAdminList().then((res) => {
      setData(res.Data?.map((item, index) => ({ ...item, serial: index + 1 })));
      setIsLoading(false);
    });
  };

  const fillData = useMemo(
    () =>
      data?.filter((item) =>
        item.FullName?.toLowerCase().includes(searchKey.toLowerCase())
      ),
    [data, searchKey]
  );

  const statusChange = (id: string, isActive: boolean) => {
    setData((prev) =>
      prev?.map((item) =>
        item.Id === id ? { ...item, IsActive: isActive } : item
      )
    );
  };

  const handleDelete = async (id: string) => {
    try {
      await ApiAdmin.deleteAdmin(id);
      getAdminUserList();
      showSuccessToast("Admin deleted Successfully");
    } catch (error: any) {
      showErrorToast(error.response?.data?.Message || error.message);
    }
  };
  const adminTableId = "admin-table-id";
  const tableHeight = useHeightUptoBottom(adminTableId).height;
  return (
    <div id={adminTableId}>
      <EditableTable
        className="flex-grow-1 align-items-center justify-content-center"
        height={parseFloat(tableHeight)}
        data={fillData}
        loading={loading}
      >
        <Column>
          <RegAuthHeaderCell>SL No</RegAuthHeaderCell>
          <Cell dataKey="serial" />
        </Column>
        <Column flexGrow={1}>
          <RegAuthHeaderCell>Name</RegAuthHeaderCell>
          <Cell dataKey="FullName" className="table-name-data" />
        </Column>
        <Column flexGrow={1}>
          <RegAuthHeaderCell>Email</RegAuthHeaderCell>
          <Cell dataKey="Email" />
        </Column>
        <Column flexGrow={1}>
          <RegAuthHeaderCell>Registration Date</RegAuthHeaderCell>
          <DateCell dataKey="CreateDate" />
        </Column>
        <Column flexGrow={1}>
          <RegAuthHeaderCell>Status</RegAuthHeaderCell>
          <BadgeCell dataKey="IsActive" />
        </Column>
        <Column flexGrow={1} align="center" fixed="right">
          <RegAuthHeaderCell>Action</RegAuthHeaderCell>
          <ActionCell onChange={statusChange} onDeleteChange={handleDelete} />
        </Column>
      </EditableTable>
    </div>
  );
};
